import clone from 'lodash/clone'
import filter from 'lodash/filter'
import cloneDeep from 'lodash/cloneDeep'

export const MultiSelectPopOverStore = {
  searchText: '',
  isSelectAllChecked: false,
  selectedValues: [] as any[],
  listItems: [],
  filterData: [] as any[],
  onApply: null as any,
  initialize(listItems: any, filteredValues: any, onApply: Function) {
    this.listItems = listItems
    this.onApply = onApply as any
    if (filteredValues !== undefined) {
      this.selectedValues = [...filteredValues]
    } else {
      this.setSelectAll()
    }
  },

  setFilterData() {
    /**
     * If search key is present filter data
     */
    let results: any[] = []
    const searchText = this.searchText
    const data = cloneDeep(this.listItems)
    if (searchText) {
      results = filter(data, function (item: string) {
        return item.toLowerCase().indexOf(searchText.toLowerCase()) > -1
      })
    }
    this.filterData = results
    if (results.length && !this.isSelectAllChecked) {
      this.setSelectAll()
    }
  },

  toggleCheckbox(event) {
    const currentIndex = this.selectedValues.indexOf(event.target.value)
    let selectedValues = clone(this.selectedValues)
    currentIndex === -1
      ? selectedValues.push(event.target.value)
      : selectedValues.splice(currentIndex, 1)
    if (currentIndex !== -1 && this.isSelectAllChecked) {
      this.isSelectAllChecked = false
    }
    this.selectedValues = [...selectedValues]
  },

  setSelectAll() {
    if (this.listItems.length) {
      this.isSelectAllChecked = !this.isSelectAllChecked
      this.selectedValues = this.isSelectAllChecked ? [...this.listItems] : []
    }
  },

  onClear() {
    this.isSelectAllChecked = true
    this.selectedValues = [...this.listItems]
    this.onApply(this.isSelectAllChecked, this.selectedValues)
  },

  onApplyClick() {
    this.filterData.length
      ? this.onApply(false, this.filterData)
      : this.onApply(this.isSelectAllChecked, this.selectedValues)
  },

  handleSearchTextChange(event) {
    this.searchText = event.target.value
    this.setFilterData()
  }
}
